import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@core/constants';
import { Ad, GetAdListCountResponse, GetAdListResponse, GetPlantierAdListCountResponse } from '@core/models/ad.model';
import { LocaleService } from '@shared/services/locale.service';
import { BehaviorSubject, Observable, map } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AdsApi {
	constructor(private readonly http: HttpClient, private readonly localeService: LocaleService) {}

	upgradeAd = new BehaviorSubject(false);

	//not using getVipAdList function currently
	getVipAdList(): Observable<Ad[]> {
		return this.http
			.post<GetAdListResponse>(`${API.ads.adList}`, {
				lang: this.localeService.lang,
			})
			.pipe(map((data: GetAdListResponse) => data?.response || []));
	}

	getVipList(body: FormData): Observable<Ad[]> {
		return this.http.post<GetAdListResponse>(`${API.ads.adList}`, body).pipe(map((data: GetAdListResponse) => data?.response || []));
	}

	getAdListCount(): Observable<GetAdListCountResponse> {
		return this.http.post<GetAdListCountResponse>(API.ads.adListCount, {
			lang: this.localeService.lang,
		});
	}

	getPlanTierAdListCount(): Observable<GetPlantierAdListCountResponse> {
		return this.http.post<GetPlantierAdListCountResponse>(API.ads.adListCount, {
			lang: this.localeService.lang,
			type: 'plantierAds',
		});
	}

	get upgradeAd$(): Observable<Boolean> {
		return this.upgradeAd.asObservable();
	}
}
